import { render, staticRenderFns } from "./sidongRing.vue?vue&type=template&id=4238d719&scoped=true&"
import script from "./sidongRing.vue?vue&type=script&lang=js&"
export * from "./sidongRing.vue?vue&type=script&lang=js&"
import style0 from "./sidongRing.vue?vue&type=style&index=0&id=4238d719&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4238d719",
  null
  
)

export default component.exports